import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { ref: "qPageDivRef" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  "aria-hidden": "true",
  class: "hidden"
}, "ESP Kobudo", -1 /* HOISTED */)

import { computed, onMounted, onBeforeUnmount, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useFocus } from '@vueuse/core';

// Personal components
import LayoutHeader from '@layouts/LayoutHeader.vue';
import LayoutLeftSide from '@layouts/LayoutLeftSide.vue';
import LayoutFooter from '@layouts/LayoutFooter.vue';
import LayoutFooterConsole from '@layouts/LayoutFooterConsole.vue';
import SkipLinkComponent from '@components/SkipLinkComponent.vue';
import BannerVersion from '@components/banner/BannerVersion.vue';

// Stores
import { useUiStore } from '@stores/ui';

// ViewModel
import { useGlobalVM } from '@viewmodel/global.vm';

// Personal libs
import { SkipLinkEnum } from '@shared/enum/skip-link.enum';
import { DeviceOrientation } from '@shared/enum/device-orientation.enum';
import { BusEventEnum } from '@shared/enum/bus/bus-events.enum';
import bus from '@shared/lib/eventbus.lib';
import { QPage } from 'quasar';
import { IUser } from '@shared/interface/model.interface';
import { RoleEnum } from '@shared/enum/role.enum';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

/**
 * Globals
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutContainer',
  setup(__props) {

// Vendor
const router = useRouter();

/**
 * Elements
 */
const qPageMain = ref<QPage>();
const { focused: qPageMainFocused } = useFocus(qPageMain);

/**
 * Viewmodel
 */
const { isMobile } = useGlobalVM();

/**
 * Stores
 */
const uiStore = useUiStore();

/**
 * Computed properties
 */
const orientation = computed<DeviceOrientation | undefined>(
  () => uiStore.uiOrientation,
);
const connectedUser = computed<IUser | undefined>(
  () => sessionManager.currentUser.value,
);
const isDeveloper = computed<boolean>(
  () => connectedUser.value?.roles?.includes(RoleEnum.ROLE_DEV) === true,
);

/**
 * Methods
 */
function onScroll(position) {
  bus.emit(BusEventEnum.SCROLL_EVENT, position);
}

/**
 * Hooks
 */
onMounted(() => {
  bus.on(BusEventEnum.DO_FOCUS_ON_MAIN, () => {
    qPageMainFocused.value = true;
  });
});

onBeforeUnmount(() => {
  bus.off(BusEventEnum.DO_FOCUS_ON_MAIN);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: 
      orientation.value === _unref(DeviceOrientation).PORTRAIT ? 'hHh LpR fFr' : 'hhh LpR fff'
    ,
    onScroll: onScroll
  }, {
    default: _withCtx(() => [
      _createCommentVNode(" Liens d'évitement "),
      _createVNode(SkipLinkComponent, { class: "z-index-foreground" }),
      _createVNode(LayoutHeader),
      _createVNode(LayoutLeftSide),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(QPage), {
              id: _unref(SkipLinkEnum).NAVIGATION_MAIN,
              ref_key: "qPageMain",
              ref: qPageMain,
              role: "main",
              padding: !_unref(isMobile),
              class: "q-ma-none q-pa-none",
              tabindex: "0"
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createCommentVNode(" Banner version : display if delta between local and remote version "),
                _createVNode(BannerVersion),
                _createElementVNode("div", {
                  class: _normalizeClass({'q-pa-sm': !_unref(isMobile)})
                }, [
                  _createVNode(_component_router_view, null, {
                    default: _withCtx(({ Component }) => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                        key: _unref(router).currentRoute.value.fullPath
                      }))
                    ]),
                    _: 1 /* STABLE */
                  })
                ], 2 /* CLASS */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["id", "padding"])
          ], 512 /* NEED_PATCH */)
        ]),
        _: 1 /* STABLE */
      }),
      (!_unref(isMobile))
        ? (_openBlock(), _createBlock(LayoutFooter, { key: 0 }))
        : _createCommentVNode("v-if", true),
      (_unref(isMobile) && isDeveloper.value)
        ? (_openBlock(), _createBlock(LayoutFooterConsole, { key: 1 }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["view"]))
}
}

})